// components/Button.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React, { Fragment, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { typography } from '@material-ui/system';

const useStyles = makeStyles((theme) => 
  createStyles({
    button: {

    }
  })
)

export default function AMRCButton({ fullWidth, href, color, children }) {
  const classes = useStyles();
  return (
    <Button 
      variant="contained"
      fullWidth={fullWidth}
      href={href}
      size="large"
      className={classes.button}
      width="md"
      color={color}>
      <Typography variant="h6" color="inherit">
        { children }
      </Typography> 
    </Button>
  );
}

AMRCButton.defaultProps = {
  fullWidth: true,
  href: '#',
  color: 'secondary'
}